import { magicNumbers } from 'utils';

export const nativePlatformsFiltersInitialState = {
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      member_count: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:memberCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:resourceBasedOn',
  },
  publishRateFilter: {
    hasFilter: false,
    isOpen: false,
    value: false,
    componentName: 'publishRateFilter',
    translateKey: 'filter:resourceActivity',
  },
};
